import "./ArchiveProductTemplate.module.css"
import AutoMotiGalvene from "@/reusable_sections/Header"
import ArchiveTitleSection from "./sections/ArchiveTitleSection"
import ShopContent from "./sections/ShopContent"
import Footer from "@/reusable_sections/Footer"

export default function ArchiveProductTemplatePage() {

  return (
    <div>
      <AutoMotiGalvene />
      <ArchiveTitleSection />
      <ShopContent />
      <Footer />
    </div>
  )
}
